import { render, staticRenderFns } from "./registration-device.vue?vue&type=template&id=3045b30e&scoped=true"
import script from "./registration-device.vue?vue&type=script&lang=js"
export * from "./registration-device.vue?vue&type=script&lang=js"
import style1 from "./registration-device.vue?vue&type=style&index=1&id=3045b30e&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3045b30e",
  null
  
)

export default component.exports